<template>
    <base-button
        @click="onClick"
        :disabled="disabled"
        :loading="loading"
        :text="text"
        size="big"
        color="green"
        radius="12px"
        style="font-size: 14px;"
    />
</template>

<script>
import BaseButton from "../../defaults/BaseButton.vue";

export default {
    name: "AuthButton",
    components: {BaseButton},
    props: {
        text: {
            type: String
        },
        disabled: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        onClick() {
            this.$emit("click")
        }
    }
}
</script>

<style scoped>

</style>